import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock, Flame, Droplets, Bird,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

// Iconos locales extra de "Alba": vela (ceremonia), agua (bautismo), paloma.
const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
  vela: Flame,
  agua: Droplets,
  paloma: Bird,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="bt-seccion" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="bt-titulo-itinerario" />
        <Reveal>
          <ul className="bt-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="bt-itinerario-item" key={i} data-testid={`bt-itinerario-item-${i}`}>
                  <span className="bt-itinerario-hora">{item.hora}</span>
                  <div className="bt-itinerario-cuerpo">
                    <h3 className="bt-itinerario-titulo">
                      <Icono size={14} strokeWidth={1.5} />
                      {item.titulo}
                    </h3>
                    {item.descripcion && <p className="bt-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
